import {Skeleton, Table, TableCell} from "@nike/eds";
import {DownloadLink} from "./DownloadLink"

export function BalancingResultsTable({balancingReports, reportS3Bucket, reportRegion, loading}) {

    return (
        <div className="downloadTable">
            <Table>
                <tbody>
                {loading &&
                    <tr>
                        <TableCell><Skeleton height={35} width={"100%"} /></TableCell>
                    </tr>
                }
                {!loading && balancingReports && balancingReports.map((report, idx) => (
                    <tr key={idx}>
                        <TableCell>
                            <DownloadLink type={"balancing"} payloadBucket={reportS3Bucket} payloadRegion={reportRegion} payloadPath={report.path} payloadVersion={report.version} />
                        </TableCell>
                    </tr>
                ))}
                </tbody>
            </Table>
        </div>
    );
}